export enum BrokerFormFieldNames {
  CompanyName = 'companyName',
  Phone = 'phone',
  ComplaintEmail = 'complaintEmail',
  RegistrationNumber = 'registrationNumber',
  Capital = 'capital',
  RcsCity = 'rcsCity',
  RcsNumber = 'rcsNumber',
  OriasNumber = 'oriasNumber',
  Rcp = 'rcp',
  Address = 'address',
  FirstName = 'firstName',
  LastName = 'lastName',
  PlateformeIds = 'plateformeIds',
  RoleIds = 'roleIds',
  IsActive = 'isActive',
  Username = 'username',
  Password = 'password',
  Email = 'email',
  Collaborators = 'collaborators',
  SousNature = 'sousNature',
}
